/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Manufacturer,
  ManufacturerInput,
  ManufacturerOptions,
  ManufacturerOptionsParams,
  Manufacturers,
  ManufacturersParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create Manufacturer
 */
export const createManufacturer = (
    manufacturerInput: MaybeRefOrGetter<ManufacturerInput>,
 signal?: AbortSignal
) => {
      manufacturerInput = toValue(manufacturerInput);

      return axiosClient<Manufacturer>(
      {url: `/manufacturers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: manufacturerInput, signal
    },
      );
    }




export const getCreateManufacturerMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createManufacturer>>, TError,{data: ManufacturerInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createManufacturer>>, TError,{data: ManufacturerInput}, TContext> => {

const mutationKey = ['createManufacturer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createManufacturer>>, {data: ManufacturerInput}> = (props) => {
          const {data} = props ?? {};

          return  createManufacturer(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateManufacturerMutationResult = NonNullable<Awaited<ReturnType<typeof createManufacturer>>>
    export type CreateManufacturerMutationBody = ManufacturerInput
    export type CreateManufacturerMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Create Manufacturer
 */
export const useCreateManufacturer = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createManufacturer>>, TError,{data: ManufacturerInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createManufacturer>>,
        TError,
        {data: ManufacturerInput},
        TContext
      > => {
      return useMutation(getCreateManufacturerMutationOptions(options), queryClient);
    }
    /**
 * @summary Manufacturers list
 */
export const manufacturers = (
    params?: MaybeRefOrGetter<ManufacturersParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Manufacturers>(
      {url: `/manufacturers`, method: 'GET',
        params, signal
    },
      );
    }




export const getManufacturersQueryKey = (params?: MaybeRefOrGetter<ManufacturersParams>,) => {
    return [
    'manufacturers', ...(params ? [params] : [])
    ] as const;
    }


export const getManufacturersQueryOptions = <TData = Awaited<ReturnType<typeof manufacturers>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ManufacturersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof manufacturers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getManufacturersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof manufacturers>>> = ({ signal }) => manufacturers(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof manufacturers>>, TError, TData>
}

export type ManufacturersQueryResult = NonNullable<Awaited<ReturnType<typeof manufacturers>>>
export type ManufacturersQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Manufacturers list
 */

export function useManufacturers<TData = Awaited<ReturnType<typeof manufacturers>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ManufacturersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof manufacturers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getManufacturersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Manufacturer Options
 */
export const manufacturerOptions = (
    params?: MaybeRefOrGetter<ManufacturerOptionsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<ManufacturerOptions>(
      {url: `/manufacturers/options`, method: 'GET',
        params, signal
    },
      );
    }




export const getManufacturerOptionsQueryKey = (params?: MaybeRefOrGetter<ManufacturerOptionsParams>,) => {
    return [
    'manufacturers','options', ...(params ? [params] : [])
    ] as const;
    }


export const getManufacturerOptionsQueryOptions = <TData = Awaited<ReturnType<typeof manufacturerOptions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ManufacturerOptionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof manufacturerOptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getManufacturerOptionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof manufacturerOptions>>> = ({ signal }) => manufacturerOptions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof manufacturerOptions>>, TError, TData>
}

export type ManufacturerOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof manufacturerOptions>>>
export type ManufacturerOptionsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Manufacturer Options
 */

export function useManufacturerOptions<TData = Awaited<ReturnType<typeof manufacturerOptions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ManufacturerOptionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof manufacturerOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getManufacturerOptionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy Manufacturer
 */
export const destroyManufacturer = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Manufacturer>(
      {url: `/manufacturers/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyManufacturerMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyManufacturer>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyManufacturer>>, TError,{id: string}, TContext> => {

const mutationKey = ['destroyManufacturer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyManufacturer>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroyManufacturer(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyManufacturerMutationResult = NonNullable<Awaited<ReturnType<typeof destroyManufacturer>>>

    export type DestroyManufacturerMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Destroy Manufacturer
 */
export const useDestroyManufacturer = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyManufacturer>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyManufacturer>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDestroyManufacturerMutationOptions(options), queryClient);
    }
    /**
 * @summary Manufacturer Detail
 */
export const manufacturer = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Manufacturer>(
      {url: `/manufacturers/${id}`, method: 'GET', signal
    },
      );
    }




export const getManufacturerQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'manufacturers',id
    ] as const;
    }


export const getManufacturerQueryOptions = <TData = Awaited<ReturnType<typeof manufacturer>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof manufacturer>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getManufacturerQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof manufacturer>>> = ({ signal }) => manufacturer(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof manufacturer>>, TError, TData>
}

export type ManufacturerQueryResult = NonNullable<Awaited<ReturnType<typeof manufacturer>>>
export type ManufacturerQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Manufacturer Detail
 */

export function useManufacturer<TData = Awaited<ReturnType<typeof manufacturer>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof manufacturer>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getManufacturerQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Manufacturer
 */
export const updateManufacturer = (
    id: MaybeRefOrGetter<string>,
    manufacturerInput: MaybeRefOrGetter<ManufacturerInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
manufacturerInput = toValue(manufacturerInput);

      return axiosClient<Manufacturer>(
      {url: `/manufacturers/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: manufacturerInput, signal
    },
      );
    }




export const getUpdateManufacturerMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateManufacturer>>, TError,{id: string;data: ManufacturerInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateManufacturer>>, TError,{id: string;data: ManufacturerInput}, TContext> => {

const mutationKey = ['updateManufacturer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateManufacturer>>, {id: string;data: ManufacturerInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateManufacturer(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateManufacturerMutationResult = NonNullable<Awaited<ReturnType<typeof updateManufacturer>>>
    export type UpdateManufacturerMutationBody = ManufacturerInput
    export type UpdateManufacturerMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update Manufacturer
 */
export const useUpdateManufacturer = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateManufacturer>>, TError,{id: string;data: ManufacturerInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateManufacturer>>,
        TError,
        {id: string;data: ManufacturerInput},
        TContext
      > => {
      return useMutation(getUpdateManufacturerMutationOptions(options), queryClient);
    }
